import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faGrid2 } from '@fortawesome/pro-regular-svg-icons/faGrid2';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { clsx } from 'clsx';
import { useProductsFilter } from '../../../../Context/ProductsFilterContext';
import style from './ProductViewSwitcher.module.scss?module';

const ProductViewSwitcher = () => {
  const { filters, updateFilters } = useProductsFilter();
  const { view } = filters;

  const handleSwitchProductView = async (newView: 'grid' | 'list' | 'table') => {
    if (newView !== view) {
      updateFilters({ view: newView, page: '1' });
    }
  };

  return (
    <div
      className="d-flex align-items-center gap-1"
      aria-label="Toggle product view"
      role="group"
    >
      <button
        type="button"
        aria-pressed={view === 'grid'}
        aria-label="Enable grid view"
        className={clsx(style.ViewIconButton, view === 'grid' && style.Active)}
        onClick={() => handleSwitchProductView('grid')}
      >
        <FontAwesomeIcon icon={faGrid2} />
      </button>

      {filters.favs_only !== '1' ? (
        <>
          <button
            type="button"
            aria-pressed={view === 'list'}
            aria-label="Enable list view"
            className={clsx(style.ViewIconButton, view === 'list' && style.Active)}
            onClick={() => handleSwitchProductView('list')}
          >
            <FontAwesomeIcon icon={faList} />
          </button>
          <button
            type="button"
            aria-pressed={view === 'table'}
            aria-label="Enable table view"
            className={clsx(style.ViewIconButton, style.TableViewButton, view === 'table' && style.Active)}
            onClick={() => handleSwitchProductView('table')}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </>
      ) : null}
    </div>
  );
};

export default ProductViewSwitcher;
